export * from './answers.service';
import { AnswersService } from './answers.service';
export * from './answers.serviceInterface'
export * from './customerIdentification.service';
import { CustomerIdentificationService } from './customerIdentification.service';
export * from './customerIdentification.serviceInterface'
export const APIS = [AnswersService, CustomerIdentificationService];
